import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import AgentsList from "./AgentsList";
import CreateAgent from "./CreateAgent";
import CreateEventAgent from "./CreateEventAgent";
import CreateSignalAgent from "./CreateSignalAgent";
import { withSignals } from "../signals/signalsGate";
import CreateListProspector from "./CreateListProspector";
import CreateCompanyProspector from "./CreateCompanyProspector";
import CreateLookalikeProspector from "./CreateLookalikeProspector";
import CreateLinkedInImport from "./CreateLinkedInImport";
import CreateReplyRouter from "./CreateReplyRouter";
import CreateAccountProspector from "./CreateAccountProspector";
import CreateActivityReport from "./CreateActivityReport";
import BuildAgent from "./BuildAgent";
import NewAgentChooser from "./NewAgentChooser";
import AgentTemplatesPage from "./AgentTemplates";
import AgentDetail from "./AgentDetail";
import ApprovalsQueue from "./ApprovalsQueue";
import AgentRunLive from "./AgentRunLive";
import "./agents.scss";

const CreateSignalAgentRoute = withSignals(CreateSignalAgent);

/** Routing for the Agents section (mounted at /agents by DashboardRouting). */
const AgentsRouting = () => (
  <Switch>
    <Route exact path="/agents" component={AgentsList} />
    <Route exact path="/agents/new" component={NewAgentChooser} />
    <Route exact path="/agents/templates" component={AgentTemplatesPage} />
    <Redirect exact from="/agents/library" to="/agents/templates" />
    <Route exact path="/agents/new/icp" component={CreateAgent} />
    <Route exact path="/agents/new/event" component={CreateEventAgent} />
    <Route exact path="/agents/new/signal" component={CreateSignalAgentRoute} />
    <Route exact path="/agents/new/list" component={CreateListProspector} />
    <Route exact path="/agents/new/companies" component={CreateCompanyProspector} />
    <Route exact path="/agents/new/lookalike" component={CreateLookalikeProspector} />
    <Route exact path="/agents/new/linkedin" component={CreateLinkedInImport} />
    <Route exact path="/agents/new/reply" component={CreateReplyRouter} />
    <Route exact path="/agents/new/abm" component={CreateAccountProspector} />
    <Route exact path="/agents/new/activity-report" component={CreateActivityReport} />
    <Route exact path="/agents/new/custom" component={BuildAgent} />
    <Route exact path="/agents/:id/edit" component={BuildAgent} />
    <Route exact path="/agents/approvals" component={ApprovalsQueue} />
    <Route exact path="/agents/:id/runs/:runId" component={AgentRunLive} />
    <Route exact path="/agents/:id" component={AgentDetail} />
    <Redirect to="/agents" />
  </Switch>
);

export default AgentsRouting;
